import LegalDocsTabs from 'components/LegalDocsTabs'
import SEO from 'components/SEO'
import Heading from 'new-components/Heading'
import TextDanger from 'new-components/partnesComponents/TextDanger'
import { useHistory } from 'react-router'
import { PrivacyText, SchedulingPrivacyText } from './mockPrivacy'
import * as Styles from './styles'

interface IPrivacyPolicyProps {
  isSchedulingPrivacy?: boolean
}

function PrivacyPolicy({ isSchedulingPrivacy: schedulingPrivacy }: IPrivacyPolicyProps) {
  const history = useHistory()
  const isSchedulingPrivacy = history.location.pathname.includes('agendamento') || schedulingPrivacy
  return (
    <Styles.Container>
      <SEO
        title={isSchedulingPrivacy ? 'Política de Agendamento' : 'Política de Privacidade'}
        description={
          isSchedulingPrivacy
            ? 'Política de uso da plataforma de agendamento de consulta da Cannect.'
            : 'Política de privacidade da Cannect. Saiba como coletamos, usamos e protegemos seus dados pessoais.'
        }
        canonical={isSchedulingPrivacy ? '/politica-de-agendamento' : '/politica-de-privacidade'}
        noindex
      />
      {!isSchedulingPrivacy && <LegalDocsTabs />}
      <Heading defaultColor="darkGrey">
        {isSchedulingPrivacy ? 'Política de uso da plataforma de agendamento de consulta' : 'Política de privacidade'}
      </Heading>
      <TextDanger text={isSchedulingPrivacy ? SchedulingPrivacyText : PrivacyText} />
    </Styles.Container>
  )
}

export default PrivacyPolicy
